import { EmptySpin } from "molecules/ui/EmptySpin/EmptySpin";
import { type NiceModalHandler, antdModalV5 } from "@ebay/nice-modal-react";
import { Result } from "antd";
import { VyneModal } from "@vyne-shared/components/vyneModal/VyneModal";

/**
 * Show a spinner while P/RP provisioning for take-a-payment, or an error if provisioning failed after several
 * retries (and the provisioning query is no longer loading).
 */
export const ProvisionSpin = ({ isProvisioning }: { readonly isProvisioning: boolean }) =>
    isProvisioning ? <EmptySpin tip="One moment..." /> : <Result status="500" title="Unable to provision patient" />;

interface ProvisionSpinModalProps {
    readonly modal: NiceModalHandler;
    readonly isProvisioning: boolean;
}

/**
 * Modal showing a spinner while P/RP provisioning for take-a-payment, or an error if provisioning failed after several
 * retries (and the provisioning query is no longer loading).
 */
export const ProvisionSpinModal = ({ modal, isProvisioning }: ProvisionSpinModalProps) => (
    <VyneModal {...antdModalV5(modal)} title="Take a Payment" closable={!isProvisioning} footer={false}>
        <ProvisionSpin isProvisioning={isProvisioning} />
    </VyneModal>
);
